import React from 'react';
import Models from '../Models/Models.jsx';
import './Navbar.css';


function Navbar() {
    return (
        <div className="navbar">
        
            <Models />
            
        </div>
    )
}

export default Navbar;